import { render, staticRenderFns } from "./MetricItemCategory.vue?vue&type=template&id=5a56ad37&scoped=true&"
import script from "./MetricItemCategory.vue?vue&type=script&lang=js&"
export * from "./MetricItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./MetricItemCategory.vue?vue&type=style&index=0&id=5a56ad37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56ad37",
  null
  
)

export default component.exports